'use strict';exports.__esModule = true;exports.DEFAULT_DISPLAYED_PINS = exports.OPTION_TYPES_COMPANY = undefined;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reactRouter = require('react-router');
var _reactScroll = require('react-scroll');
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _AboutCompany = require('./AboutCompany/AboutCompany');var _AboutCompany2 = _interopRequireDefault(_AboutCompany);
var _ConsultationForm = require('./ConsultationForm/ConsultationForm');var _ConsultationForm2 = _interopRequireDefault(_ConsultationForm);
var _components = require('../../components');

var _CompanyProperties = require('./CompanyProperties/CompanyProperties');var _CompanyProperties2 = _interopRequireDefault(_CompanyProperties);
var _CompanyMap = require('./CompanyMap/CompanyMap');var _CompanyMap2 = _interopRequireDefault(_CompanyMap);
var _CompanyRealtors = require('../CompanyRealtors/CompanyRealtors');var _CompanyRealtors2 = _interopRequireDefault(_CompanyRealtors);
var _getLocalizedData3 = require('../../utils/getLocalizedData');var _getLocalizedData4 = _interopRequireDefault(_getLocalizedData3);

var _constants = require('../../constants');








var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);

var _services = require('../../services');
var _formatAddress = require('../../utils/formatAddress');var _formatAddress2 = _interopRequireDefault(_formatAddress);
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');

var _Company = require('./Company.scss');var styles = _interopRequireWildcard(_Company);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _HeaderPhones = require('./HeaderPhones/HeaderPhones');var _HeaderPhones2 = _interopRequireDefault(_HeaderPhones);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Component
// Constants
// Helpers
// styles
var getLocalizedField = function getLocalizedField(data, field, locale) {if (!data || !data[field]) {return '';
  }

  if (!data[field][locale] && !data[field][_constants.language.default]) {
    return '';
  }

  return data[field][locale] || data[field][_constants.language.default];
};

var getLocalizeCompanyData = function getLocalizeCompanyData(data, locale) {return Object.assign({},
  data, {
    name: getLocalizedField(data, 'name', locale),
    title: getLocalizedField(data, 'title', locale),
    description: getLocalizedField(data, 'description', locale),
    additional_info: getLocalizedField(data, 'additional_info', locale),
    isNameAtDefaultLang: !(0, _get2.default)(data, ['name', locale]),
    isTitleAtDefaultLang: !(0, _get2.default)(data, ['title', locale]),
    isDescriptionAtDefaultLang: !(0, _get2.default)(data, 'description', locale) });};


var OPTION_TYPES_COMPANY = exports.OPTION_TYPES_COMPANY = {
  SALE: 'forSale',
  RENT: 'forRent' };

var DEFAULT_DISPLAYED_PINS = exports.DEFAULT_DISPLAYED_PINS = OPTION_TYPES_COMPANY.SALE;
var consultationImage = 'https://res.cloudinary.com/onmap-prod/image/upload/f_auto,q_auto/v1573656970/professionals/partnership';var

Company = function (_Component) {_inherits(Company, _Component);
  function Company(props) {_classCallCheck(this, Company);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);
    var propertiesForSell = _this.getPropertiesFor('buy', props);
    var propertiesForRent = _this.getPropertiesFor('rent', props);

    _this.state = {
      propertiesForSell: propertiesForSell,
      propertiesForRent: propertiesForRent,
      captcha: null };return _this;

  }Company.prototype.

  componentWillMount = function componentWillMount() {
    this.detectLanguage(this.props);
  };Company.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(nextProps) {var

    properties =










    nextProps.properties,formSubmitting = nextProps.formSubmitting,formSubmitted = nextProps.formSubmitted,formError = nextProps.formError,formConsultationError = nextProps.formConsultationError,formConsultationSubmitted = nextProps.formConsultationSubmitted,formConsultationSubmitting = nextProps.formConsultationSubmitting,company = nextProps.company,descriptionData = nextProps.descriptionData,locale = nextProps.locale,additionalInfoData = nextProps.additionalInfoData;
    if (locale !== this.props.locale) {
      this.props.resetTranslate();

      this.detectLanguage(nextProps);
    }
    if (
    descriptionData.showOriginal &&
    !descriptionData.loading &&
    !descriptionData.loaded)
    {
      this.props.translateDescription({ q: company.description.he });
    }

    if (
    additionalInfoData.showOriginal &&
    !additionalInfoData.loading &&
    !additionalInfoData.loaded)
    {
      this.props.translateAdditionalInfo({ q: company.additional_info.he });
    }

    if (properties && properties.length && (!this.props.properties || !this.props.properties.length) ||
    !(0, _isEqual2.default)(properties, this.props.properties)) {
      var propertiesForSell = this.getPropertiesFor('buy', nextProps);
      var propertiesForRent = this.getPropertiesFor('rent', nextProps);

      this.setState({
        propertiesForSell: propertiesForSell,
        propertiesForRent: propertiesForRent });

    }

    if (this.props.formSubmitting && !formSubmitting && formSubmitted && !formError) {
      this.props.reset();
      this.props.resetReduxForm('company-contact-us');

      if (!formError) {
        this.openSuccessMessage();
      }
    }

    if (this.props.formConsultationSubmitting &&
    !formConsultationSubmitting && formConsultationSubmitted && !formConsultationError) {
      this.props.consultationReset();
      this.props.resetReduxForm('Consultation-Form');

      if (!formConsultationError) {
        this.openSuccessMessage();
      }
    }
  };Company.prototype.








































































































































































































































































































































  render = function render() {var _cx;
    var bgPhotos = {
      imgCompany: { backgroundImage: 'url(\'' + this.getMainImage() + '\')' },
      imgConsultation: { backgroundImage: 'url(\'' + consultationImage + '\')' },
      bgContactsForm: { backgroundImage: 'url(\'' + _constants.realtorLandingBottomBackground + '\')' } };var _props =

    this.props,company = _props.company,locale = _props.locale,route = _props.route,companyId = _props.companyId,descriptionData = _props.descriptionData;

    var localizeCompanyData = getLocalizeCompanyData(company, locale);
    var phoneNumber = localizeCompanyData.phone_number;var
    image = company.image,is_advanced = company.is_advanced;
    var SEOTitle = localizeCompanyData.title || localizeCompanyData.name;
    var branches = localizeCompanyData && localizeCompanyData.branches || [];
    var address = localizeCompanyData && localizeCompanyData.address ?
    (0, _formatAddress2.default)(localizeCompanyData.address[locale] || localizeCompanyData.address.en) :
    '';
    var sharingData = {
      sharingUrl: (0, _makeSharingUrl2.default)('/company/' + companyId, locale),
      sharingTitle: SEOTitle };

    var metaTitle = SEOTitle + ' | \u202BOnMap';
    var formattedImage = (0, _modifyImageLink2.default)(image, _constants.imageModifierTypes.LOGO);
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);

    var descriptionText = !descriptionData.showOriginal ?
    localizeCompanyData.description :
    descriptionData.translatedText;

    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        _react2.default.createElement(_reactHelmet2.default, { titleTemplate: this.props.translate('title', 'titleTemplate').toString() },
          _react2.default.createElement('title', null, SEOTitle),
          _react2.default.createElement('meta', { property: 'title', content: metaTitle }),
          _react2.default.createElement('meta', { property: 'og:title', content: metaTitle }),
          _react2.default.createElement('meta', { property: 'og:image', content: formattedImage }),
          _react2.default.createElement('meta', { property: 'og:image:width', content: 250 }),
          _react2.default.createElement('meta', { property: 'og:image:height', content: 250 }),
          _react2.default.createElement('meta', { property: 'og:url', content: '' + _constants.shareUrl + route }),
          _react2.default.createElement('meta', { name: 'description', content: localizeCompanyData.description }),
          _react2.default.createElement('meta', { property: 'og:description', content: localizeCompanyData.description }),
          _react2.default.createElement('link', { rel: 'canonical', href: '' + _constants.shareUrl + route }),
          multiLanguage && multiLanguage.map(function (item) {return (
              _react2.default.createElement('link', { key: item.hrefLang + '-key', rel: item.rel, hrefLang: item.hrefLang, href: item.href }));}),
          this.props.locale !== _constants.language.default && _react2.default.createElement('meta', { name: 'robots', content: 'noindex,nofollow' })),

        _react2.default.createElement(_components.CompanyInfoBlock, {
          translate: this.props.translate('companyPage'),
          title: localizeCompanyData.name,
          phoneNumber: phoneNumber,
          isMobile: this.props.isMobile,
          locale: this.props.locale,
          scrollToBlock: 'company-page-content' }),


        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.headerTop, (_cx = {}, _cx[styles.brokerCommunity] = company.is_community_member, _cx)) },
          _react2.default.createElement('span', { className: styles.bgCover, style: bgPhotos.imgCompany }),
          _react2.default.createElement('div', { className: styles.container },
            _react2.default.createElement(_AboutCompany2.default, {
              translate: this.props.translate('companyPage'),
              companyName: localizeCompanyData.name,
              companyLogo: formattedImage,
              phoneNumber: phoneNumber,
              branches: branches,
              address: address,
              company: company,
              locale: locale,
              isMobile: this.props.isMobile })),


          _react2.default.createElement('div', { className: styles.container },
            this.renderConsultationForm(
            localizeCompanyData.name,
            'headerTopForm',
            'header_top_form_phone',
            'captchaIdentifierConsultationForm-1')),


          _react2.default.createElement('div', { className: styles.container },
            this.renderShareButton(sharingData))),


        company.is_community_member && _react2.default.createElement('div', { className: styles.infoMessage }, '\u05DE\u05E9\u05D5\u05D5\u05E7\u05D9\u05DD \u05E0\u05D3\u05DC\u05F4\u05DF \u05D1-4 \u05E9\u05E4\u05D5\u05EA'),
        _react2.default.createElement(_reactScroll.Element, { name: 'company-page-content' },
          is_advanced && this.renderPromoBlock(),
          _react2.default.createElement('div', { className: styles.descriptionTextBlockWrapper },
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.container, styles.flexContainer) },
              _react2.default.createElement(_components.DescriptionTextBlock, {
                className: 'companyDescriptions',
                contentText: descriptionText,
                locale: locale,
                translate: this.props.translate,
                title: 'descriptionTitle',
                description: this.props.company.description,
                descriptionData: this.props.descriptionData,
                toggleDescriptionTranslation: this.props.toggleDescriptionTranslation,
                isTranslate: true }))),



          is_advanced && this.renderPortfolio(),
          this.renderProperties(localizeCompanyData.name),
          _react2.default.createElement('div', { className: styles.consultationWrapper, style: bgPhotos.imgConsultation },
            _react2.default.createElement('div', { className: styles.container },
              this.renderConsultationForm(
              localizeCompanyData.name,
              'consultationForm',
              'consultation_form_phone',
              'captchaIdentifierConsultationForm-2'),

              this.renderPhones(phoneNumber))),


          _react2.default.createElement('div', { className: styles.container },
            this.renderCompanyRealtors()),

          this.renderMap(),
          this.renderAdditionalInfo(localizeCompanyData.additional_info, 'additionalTitle'),
          _react2.default.createElement(_reactScroll.Element, { name: 'contacts-form-block', className: styles.contactFormWrapper, style: bgPhotos.bgContactsForm },
            _react2.default.createElement('div', { className: styles.container },
              this.renderContactUsForm(localizeCompanyData.name))))));





  };return Company;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this2 = this;this.componentWillUnmount = function () {_this2.props.resetTranslate();};this.getPropertiesFor = function (optionType) {var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.props;if (!props.properties) {return null;}var additionalTypes = optionType === 'rent' ? ['rent-short'] : [];return props.properties && props.properties.filter(function (prop) {return [optionType].concat(additionalTypes).includes(prop.option_type);});};this.getMainImage = function () {var _props2 = _this2.props,_props2$company = _props2.company,type = _props2$company.type,main_image = _props2$company.main_image,is_community_member = _props2$company.is_community_member,isMobile = _props2.isMobile,isRtl = _props2.isRtl;if (main_image) {return main_image;}var IMAGES = isMobile ? _constants.MAIN_IMAGES_MOBILE : _constants.MAIN_IMAGES;var brokerType = !isMobile && !isRtl ? _constants.PROFESSIONAL_TYPE_BROKER + '_ltr' : _constants.PROFESSIONAL_TYPE_BROKER;var key = is_community_member && type === _constants.PROFESSIONALS_TYPES.AGENCY ? brokerType : type;return IMAGES[key] || _constants.DEFAULT_MAIN_IMAGE;};this.detectLanguage = function (props) {var locale = props.locale,detectDescriptionLanguage = props.detectDescriptionLanguage,detectAdditionalInfoLanguage = props.detectAdditionalInfoLanguage;var description = (0, _get2.default)(props, 'company.description', null);var additionalInfo = (0, _get2.default)(props, 'company.additional_info', null);if (description) {var _getLocalizedData = (0, _getLocalizedData4.default)(description, locale),result = _getLocalizedData.result;detectDescriptionLanguage({ q: result, locale: locale });}if (additionalInfo) {var _getLocalizedData2 = (0, _getLocalizedData4.default)(additionalInfo, locale),_result = _getLocalizedData2.result;detectAdditionalInfoLanguage({ q: _result, locale: locale });}};this.openSuccessMessage = function () {return _this2.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'successMessage' }, _react2.default.createElement('span', null, _this2.props.translate('companyPage', 'contactsForm', 'submitting_success'))), messageModalClassName: 'company-message-modal' });};this.fetchReCaptchaToken = function (token) {_this2.setState({ captcha: token });};this.formFeedBackSubmitHandler = function (formValues) {var _props$company = _this2.props.company,email = _props$company.email,is_community_member = _props$company.is_community_member,company = _objectWithoutProperties(_props$company, ['email', 'is_community_member']);var captcha = _this2.state.captcha;var receiver_name = getLocalizedField(company, 'title', _this2.props.locale);if (captcha) {_this2.props.sendCompanyContactUsForm(Object.assign({ captcha: captcha }, formValues, { receiver_name: receiver_name, to: email, is_community_member: is_community_member }));} // hermione event
    _services.AnalyticsEventService.createCompanyEvent(_this2.props.companyId);};this.formConsultationSubmitHandler = function (formValues) {var _props$company2 = _this2.props.company,email = _props$company2.email,is_community_member = _props$company2.is_community_member,company = _objectWithoutProperties(_props$company2, ['email', 'is_community_member']);var captcha = _this2.state.captcha;var receiver_name = getLocalizedField(company, 'title', _this2.props.locale);_this2.props.sendConsultationForm(Object.assign({ captcha: captcha }, formValues, { receiver_name: receiver_name, to: email, message: formValues.message || ' - ', is_community_member: is_community_member })); // hermione event
    _services.AnalyticsEventService.createCompanyEvent(_this2.props.companyId);};this.openDetails = function (evt, propertyId) {var entityType = 'property';var route = (0, _appendLocale2.default)(_this2.props.locale, '/home_details/' + propertyId);var state = Object.assign({}, _this2.props.routeData, { pid: propertyId });if (evt.ctrlKey || evt.metaKey) {window.open(route);} else {_reactRouter.browserHistory.push({ pathname: _this2.props.route + '/pid_' + propertyId, state: state });_this2.props.openDetailsPopup({ propertyId: propertyId, entityType: entityType });} // hermione event
    _services.AnalyticsEventService.createPropertyEvent({ propertyId: propertyId, action: _constants.analyticsEventAction.VIEW });};this.renderCallUsMessage = function () {return _react2.default.createElement('div', null, _react2.default.createElement('div', null, _this2.props.translate('callOrLeaveMessage'), ':\xA0\xA0'), _react2.default.createElement('a', { href: 'tel:' + _this2.props.company.phone_number }, (0, _formatPhoneNumber.formatPhoneNumber)(_this2.props.company.phone_number)));};this.renderSubtitleMessage = function () {return _this2.props.company.type === _constants.PROFESSIONALS_TYPES.MORTGAGE ? _this2.props.translate('companyPage', 'mortgageSubtitle').toString() : '';};this.renderConsultationForm = function (companyName, className, field_id, captchaIdentifier) {return _react2.default.createElement(_ConsultationForm2.default, { fetchReCaptchaToken: _this2.fetchReCaptchaToken, locale: _this2.props.locale, field_id: field_id, companyName: companyName, className: className, translate: _this2.props.translate, onSubmit: _this2.formConsultationSubmitHandler, isRtl: _this2.props.isRtl, formSubmitting: _this2.props.formSubmitting, formSubmitted: _this2.props.formSubmitted, formConsultationError: _this2.props.formConsultationError, captchaIdentifier: captchaIdentifier });};this.renderContactUsForm = function (companyName) {return _react2.default.createElement(_components.CompanyContactUs, { fetchReCaptchaToken: _this2.fetchReCaptchaToken, locale: _this2.props.locale, companyName: companyName, translate: _this2.props.translate, onSubmit: _this2.formFeedBackSubmitHandler, isRtl: _this2.props.isRtl, formSubmitting: _this2.props.formSubmitting, formSubmitted: _this2.props.formSubmitted, formError: _this2.props.formError, captchaIdentifier: 'captchaIdentifierCompanyContactUs' });};this.renderShareButton = function (sharingData) {return _react2.default.createElement(_components.ShareButtonsRow, { isNative: _this2.props.isNative, sharingData: sharingData, isMobile: _this2.props.isMobile, locale: _this2.props.locale, copyLinkTitle: '' + _this2.props.translate('copyLink'), shareTitle: '' + _this2.props.translate('companyPage', 'shareTitle'), className: 'companySocialIcons', isHideShareTitle: true });};this.renderPhones = function (phone) {return _react2.default.createElement(_HeaderPhones2.default, { translate: _this2.props.translate('companyPage'), phoneNumber: phone, locale: _this2.props.locale, isMobile: _this2.props.isMobile, className: styles.phoneBlock, callToActionText: _this2.props.translate('companyPage', 'callNowText').toString(), isIconFill: true });};this.renderPortfolio = function () {if (!(0, _get2.default)(_this2.props, 'company.images.length')) {return null;}return _react2.default.createElement('div', { className: styles.portfolioWrapper }, _react2.default.createElement('div', { className: styles.container }, _react2.default.createElement(_components.Portfolio, { isDetailsModalOpen: _this2.props.isDetailsModalOpen, images: _this2.props.company.images || [], portfolioTitle: _this2.props.translate('companyPage', _this2.props.company.type === _constants.PROFESSIONALS_TYPES.DESIGNER ? 'PortfolioTitle' : 'galleryTitle'), translate: _this2.props.translate('propertyDetails'), changeLightboxActiveSlide: _this2.props.changeLightboxActiveSlide, isOpen: _this2.props.isLightboxOpen, hideLightbox: _this2.props.hideLightbox, locale: _this2.props.locale, isRtl: _this2.props.isRtl, openLightbox: _this2.props.openLightbox, currentImage: _this2.props.currentImage })));};this.renderProperties = function (localizedCompanyName) {if (_this2.props.company.type !== _constants.PROFESSIONALS_TYPES.AGENCY || !(0, _get2.default)(_this2.props, 'properties.length')) {return null;}return _react2.default.createElement('div', { className: styles.container }, _react2.default.createElement(_CompanyProperties2.default, { translate: _this2.props.translate, locale: _this2.props.locale, isRtl: _this2.props.isRtl, isMobile: _this2.props.isMobile, forSale: _this2.state.propertiesForSell, forRent: _this2.state.propertiesForRent, openDetails: _this2.openDetails, companyName: localizedCompanyName }));};this.renderPromoBlock = function () {var advantages = (0, _get2.default)(_this2.props, 'company.advantages', []);if (!advantages.length) {return null;}return _react2.default.createElement('div', null, _react2.default.createElement('div', { className: styles.container }, _react2.default.createElement(_components.PromoBlock, { title: _this2.props.translate('companyPage', 'promoTitle'), locale: _this2.props.locale, advantages: advantages })));};this.renderAdditionalInfo = function (contentText, addClass) {if (!contentText) {return null;}var descriptionText = !_this2.props.additionalInfoData.showOriginal ? contentText : _this2.props.additionalInfoData.translatedText;return _react2.default.createElement('div', { className: styles.descriptionTextBlockWrapper }, _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.container, styles.flexContainer, addClass) }, _react2.default.createElement(_components.DescriptionTextBlock, { className: 'companyDescriptions', contentText: descriptionText, locale: _this2.props.locale, translate: _this2.props.translate, title: 'additionTitle', description: _this2.props.company.additional_info, descriptionData: _this2.props.additionalInfoData, toggleDescriptionTranslation: _this2.props.toggleAdditionalInfoTranslation, isTranslate: true })));};this.renderMap = function () {if (_this2.props.company.type !== _constants.PROFESSIONALS_TYPES.AGENCY) {return null;}return _react2.default.createElement('div', { className: styles.mapWrapper }, _react2.default.createElement('div', { className: styles.container }, _react2.default.createElement(_CompanyMap2.default, { translate: _this2.props.translate, locale: _this2.props.locale, isMobile: _this2.props.isMobile, isRtl: _this2.props.isRtl, forSale: _this2.state.propertiesForSell, forRent: _this2.state.propertiesForRent, reviewedPins: _this2.props.reviewedPins, setPinAsReviewed: _this2.props.setPinAsReviewed, openDetails: _this2.openDetails })));};this.renderCompanyRealtors = function () {var _props3 = _this2.props,is_advanced = _props3.company.is_advanced,locale = _props3.locale;var realtors = (0, _get2.default)(_this2.props, 'company.realtors', []);if (!realtors.length) {return null;}return _react2.default.createElement('div', { className: styles.realtorsBlock }, _react2.default.createElement('div', { className: styles.title }, _this2.props.translate('companyPage', 'officeStaff')), _react2.default.createElement(_CompanyRealtors2.default, { locale: locale, isAdvanced: is_advanced, realtors: realtors }));};};Company.propTypes = {
  company: _propTypes2.default.object,
  properties: _propTypes2.default.array,
  routeData: _propTypes2.default.object,
  consultation: _propTypes2.default.object,
  formError: _propTypes2.default.object,
  formConsultationError: _propTypes2.default.object,
  formConsultationSubmitted: _propTypes2.default.bool,
  formConsultationSubmitting: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  sendConsultationForm: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  resetReduxForm: _propTypes2.default.func,
  consultationReset: _propTypes2.default.func,
  sendCompanyContactUsForm: _propTypes2.default.func,
  showMessage: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  route: _propTypes2.default.string,
  companyId: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  reviewedPins: _propTypes2.default.array,
  setPinAsReviewed: _propTypes2.default.func,
  formSubmitting: _propTypes2.default.bool,
  formSubmitted: _propTypes2.default.bool,
  isLightboxOpen: _propTypes2.default.bool,
  isDetailsModalOpen: _propTypes2.default.bool,
  openLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  currentImage: _propTypes2.default.number,
  isRtl: _propTypes2.default.bool,
  descriptionData: _propTypes2.default.object,
  additionalInfoData: _propTypes2.default.object,
  translateDescription: _propTypes2.default.func,
  translateAdditionalInfo: _propTypes2.default.func,
  detectAdditionalInfoLanguage: _propTypes2.default.func,
  detectDescriptionLanguage: _propTypes2.default.func,
  isNative: _propTypes2.default.bool,
  toggleDescriptionTranslation: _propTypes2.default.func,
  toggleAdditionalInfoTranslation: _propTypes2.default.func,
  resetTranslate: _propTypes2.default.func };exports.default =


Company;


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/Company.js
// module id = 374
// module chunks = 0